import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as MaterialUI from 'material-ui';
import { push } from 'react-router-redux';
import FontAwesome from 'react-fontawesome';
import { Row, Col } from 'reactstrap';
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert';

@connect(store => ({
  userRoles: store.getIn(['user', 'roles']),
}))
class ItemList extends React.Component {
  delete = grupo => this.props.delete(grupo);
  add = grupo => this.props.dispatch(push('/dashboard/grupos/add/' + grupo.id));
  render() {
    const { grupo, userRoles, crearSimilar } = this.props;
    return (
      <Row>
        <Col md="12">
          <MaterialUI.ListItem
            primaryText={grupo.nombre}
            onTouchTap={this.add.bind(this, grupo)}
            rightIconButton={
              userRoles &&
              userRoles.find(v => v == 'admin' || v == 'devAdmin' || v == 'administrador_grupos') && (
                <MaterialUI.IconMenu
                  iconButtonElement={
                    <MaterialUI.IconButton touch={true} tooltipPosition="bottom-left">
                      <MoreVertIcon />
                    </MaterialUI.IconButton>
                  }
                >
                  <MaterialUI.MenuItem onTouchTap={this.props.delete.bind(this, grupo)}>
                    <FontAwesome name="trash" className="red" /> Eliminar
                  </MaterialUI.MenuItem>
                  <MaterialUI.MenuItem onTouchTap={() => crearSimilar(grupo)}>
                    <FontAwesome name="copy" className="green" /> Copiar
                  </MaterialUI.MenuItem>
                </MaterialUI.IconMenu>
              )
            }
          />
          <MaterialUI.Divider />
        </Col>
      </Row>
    );
  }
}

ItemList.propTypes = {
  delete: PropTypes.func.isRequired,
  grupo: PropTypes.object.isRequired,
};
export default ItemList;



// WEBPACK FOOTER //
// src/modules/grupos/components/itemList.js